import { Injectable } from '@angular/core';
import { ModalOptions, ModalService } from '@healthcatalyst/cashmere';
import { Observable } from 'rxjs';
import { IdleUserSignOutModalComponent } from './idle-user-sign-out-modal.component';

@Injectable({
    providedIn: 'root'
})
export class IdleUserSignOutModalService {
    constructor(private modalService: ModalService) {}

    open(warningTimeoutInMs: number): Observable<any> {
        const modalOptions: ModalOptions = {
            ignoreEscapeKey: true,
            ignoreOverlayClick: true,
            size: 'md',
            data: warningTimeoutInMs
        };

        // Temporarily set allowMultiple to allow on top of other modals
        try {
            this.modalService.allowMultiple = true;
            const modalRef = this.modalService.open(IdleUserSignOutModalComponent, modalOptions);
            return modalRef.result;
        } finally {
            this.modalService.allowMultiple = false;
        }
    }
}
